import { ICategoryDetail } from '@shared/Types'

export interface ICategoryDetailOtherProps {
  mediaId: string
}

export type TCategoryDetailDTO = Pick<ICategoryDetail, 'MediaId' | 'CategoryId' | 'Category'> & {
  Id?: string
}

export enum EChangeValue {
  Add = 'Add',
  Remove = 'Remove'
}

export interface ISelectCategoryChange {
  value: TCategoryDetailDTO
  status: EChangeValue
}
